var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-sheet",
    { staticClass: "rounded-xl my-6 subscription-page-container" },
    [
      _c(
        "div",
        { staticClass: "scrolling-content" },
        [
          _c(
            "v-container",
            { staticClass: "fill-height" },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", lg: "5" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-8 text-center rounded-lg",
                          attrs: { outlined: "" },
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "80", color: "red darken-1" } },
                            [_vm._v("mdi-alert-circle-outline")]
                          ),
                          _c(
                            "h1",
                            {
                              staticClass:
                                "text-h4 font-weight-bold text--primary mt-6",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("PaymentPage.PaymentFail.title"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-body-1 text--secondary mt-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("PaymentPage.PaymentFail.description")
                                )
                              ),
                            ]
                          ),
                          _c("v-divider", { staticClass: "my-6" }),
                          _vm.errorMessage
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "text-h6 font-weight-semibold text--primary mb-4",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PaymentPage.PaymentFail.errorDetails"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "text-left",
                                      attrs: {
                                        border: "left",
                                        "colored-border": "",
                                        color: "red",
                                        elevation: "2",
                                      },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.PaymentFail.reason"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " " + _vm._s(_vm.errorMessage) + " "
                                      ),
                                    ]
                                  ),
                                  _c("v-simple-table", {
                                    staticClass: "mt-4",
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-left text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.PaymentFail.errorCode"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-right text--primary font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.errorCode)
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-left text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.PaymentFail.orderId"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-right text--primary font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.orderId)
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1867346433
                                    ),
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-caption text--secondary mt-4",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PaymentPage.PaymentFail.contactSupport"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text mt-6",
                              attrs: {
                                to: _vm.retryUrl,
                                "x-large": "",
                                depressed: "",
                                color: "blue",
                                block: "",
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-reload"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "PaymentPage.PaymentFail.retryPayment"
                                    )
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "auth-layout-footer" },
            [_c("client-footer-component")],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }